import React from "react";
import { Dialog } from "primereact/dialog";
import LogChart, { LogChartOverlaySeries } from "./LogChart";
import {
  ChartDialogContent,
  FloatingLogChartDialogStyles,
} from "./LogChartDialog.styles";
import { getChartTitleTranslation } from "../../translations/translations";

interface LogChartDialogProps {
  data: any;
  title: string;
  indexCurve?: string;
  overlaySeries?: LogChartOverlaySeries[];
  depthReferenceLines?: number[];
  curvePrecisions?: Record<string, number>;
  autoFitKey?: string;
  storageKey?: string;
  hiddenSeriesOverride?: Record<string, boolean>;
  highlightedSeriesMnemonic?: string;
  dialogIndex?: number;
  onHiddenSeriesChange?: (hiddenSeries: Record<string, boolean>) => void;
  onClose: () => void;
}

const LogChartDialog: React.FC<LogChartDialogProps> = ({
  data,
  title,
  indexCurve,
  overlaySeries,
  depthReferenceLines,
  curvePrecisions,
  autoFitKey,
  storageKey,
  hiddenSeriesOverride,
  highlightedSeriesMnemonic,
  dialogIndex = 0,
  onHiddenSeriesChange,
  onClose,
}) => {
  const translatedTitle = getChartTitleTranslation(title);
  const offset = Math.min(dialogIndex, 6) * 24;

  return (
    <>
      <FloatingLogChartDialogStyles />
      <Dialog
        visible
        onHide={onClose}
        modal={false}
        draggable
        resizable
        maximizable
        blockScroll={false}
        keepInViewport
        appendTo={document.body}
        className="log-chart-floating-dialog"
        style={{
          "--dialog-offset": `${offset}px`,
          width: "min(1050px, 100vw)",
          height: "min(640px, 100vh)",
        } as React.CSSProperties}
        contentStyle={{
          flex: 1,
          minHeight: 0,
          padding: 0,
          overflow: "hidden",
        }}
      >
        <ChartDialogContent role="region" aria-label={translatedTitle}>
          <LogChart
            key={`dialog-chart-${storageKey || title}`}
            data={data}
            title={title}
            indexCurve={indexCurve}
            overlaySeries={overlaySeries}
            depthReferenceLines={depthReferenceLines}
            curvePrecisions={curvePrecisions}
            autoFitKey={autoFitKey}
            hiddenSeriesOverride={hiddenSeriesOverride}
            highlightedSeriesMnemonic={highlightedSeriesMnemonic}
            onHiddenSeriesChange={onHiddenSeriesChange}
            storageKey={storageKey}
            onClose={onClose}
            isDialog={true}
          />
        </ChartDialogContent>
      </Dialog>
    </>
  );
};

export default LogChartDialog;
